<template>
  <div
    ref="input"
    v-click-outside="() => { focused = false }"
    :class="{
      'c-input--container-active': containerActive,
    }"
    :data-type="type"
  >
    <!-- <div
      class="c-input-overlay"
      :class="{
        'c-input-overlay_active': container,

        'c-input-overlay_active_select_mobile': type === 'select',
      }"
      @click="closeContainer"
    ></div> -->

    <div
      class="c-input"
      :class="{
        'c-input--disabled': disabled,
      }"
    >
      <div v-if="label" class="c-input-label">
        {{ label }}
        <span v-if="requiredMark" class="c-input-label__required">*</span>
        <div v-if="labelFullName" class="c-input-label-fullname">
          <c-button
            v-b-popover.html="{
              container: '#app',
              trigger: 'hover',
              content: labelFullName,
              placement: 'bottom',
            }"
            size="iconic"
            icon="info"
          />
        </div>
      </div>

      <div v-if="floatingLabel" class="c-input-floating-label-not-visible">
        {{ floatingLabel }}
        <span v-if="requiredMark" class="c-input-label__required">*</span>
        <div v-if="labelFullName" class="c-input-label-fullname">
          <c-button
            v-b-popover.html="{
              container: '#app',
              trigger: 'hover',
              content: labelFullName,
              placement: 'bottom',
            }"
            size="iconic"
            icon="info"
          />
        </div>
      </div>

      <div class="c-input-wrapper">
        <span v-if="prependArrow" class="input-arrow"> > </span>
        <div
          v-if="icon"
          class="c-input-icon"
          :class="{
            'c-input-icon_right': iconRight,
            'c-input-icon_size_small': size === 'small',
          }"
        >
          <svg
            v-if="icon === 'search'"
            class="c-input-icon-svg c-input-icon-svg_stroke"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.4142 11L15.6569 15.2426M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>

          <svg
            v-if="icon === 'calendar'"
            class="c-input-icon-calendar"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            @click="openContainer()"
          >
            <path
              d="M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z"
              stroke="#8E9CBB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M13 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <rect x="4" y="8" width="2" height="2" fill="#8E9CBB" />
            <rect x="4" y="12" width="2" height="2" fill="#8E9CBB" />
            <rect x="8" y="8" width="2" height="2" fill="#8E9CBB" />
            <rect x="8" y="12" width="2" height="2" fill="#8E9CBB" />
            <rect x="12" y="8" width="2" height="2" fill="#8E9CBB" />
            <rect x="12" y="12" width="2" height="2" fill="#8E9CBB" />
          </svg>
        </div>

        <div
          v-if="type === 'password'"
          class="c-input-icon c-input-icon_right cursor-pointer"
          @click="passwordVisible = !passwordVisible"
        >
          <svg
            v-if="passwordVisible"
            width="20"
            height="13"
            viewBox="0 0 20 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.70711 0.292893C5.31658 -0.0976311 4.68342 -0.0976311 4.29289 0.292893C3.90237 0.683417 3.90237 1.31658 4.29289 1.70711L5.70711 0.292893ZM15.2929 12.7071C15.6834 13.0976 16.3166 13.0976 16.7071 12.7071C17.0976 12.3166 17.0976 11.6834 16.7071 11.2929L15.2929 12.7071ZM18 7L18.8129 7.58235L19.2301 7L18.8129 6.41765L18 7ZM2 7L1.18706 6.41765L0.769899 7L1.18706 7.58235L2 7ZM4.29289 1.70711L15.2929 12.7071L16.7071 11.2929L5.70711 0.292893L4.29289 1.70711ZM18 7C17.1871 6.41765 17.1872 6.41744 17.1874 6.41725C17.1874 6.41721 17.1875 6.41703 17.1876 6.41695C17.1877 6.41679 17.1877 6.41671 17.1877 6.4167C17.1878 6.41668 17.1876 6.41696 17.1871 6.41753C17.1863 6.41867 17.1846 6.42098 17.1821 6.42442C17.1771 6.4313 17.1687 6.4427 17.1571 6.45831C17.1338 6.48955 17.0975 6.5376 17.0488 6.60008C16.9513 6.72511 16.8048 6.90733 16.6145 7.12764C16.2328 7.56963 15.6814 8.15767 15.0033 8.7431C13.6162 9.94076 11.847 11 10 11V13C12.5713 13 14.8021 11.5592 16.3104 10.2569C17.0801 9.59233 17.7002 8.93037 18.1281 8.43486C18.3427 8.18642 18.5105 7.97801 18.6262 7.82961C18.684 7.75537 18.729 7.696 18.7603 7.654C18.776 7.63299 18.7882 7.61631 18.797 7.60427C18.8014 7.59825 18.805 7.59339 18.8076 7.58972C18.809 7.58789 18.8101 7.58635 18.8109 7.58512C18.8114 7.58451 18.8118 7.58397 18.8121 7.5835C18.8123 7.58327 18.8125 7.58298 18.8126 7.58287C18.8128 7.5826 18.8129 7.58235 18 7ZM10 11C8.15301 11 6.38378 9.94076 4.99668 8.7431C4.31864 8.15767 3.76722 7.56963 3.38551 7.12764C3.19525 6.90733 3.0487 6.72511 2.95124 6.60008C2.90254 6.5376 2.86621 6.48955 2.84292 6.45831C2.83127 6.4427 2.82289 6.4313 2.81787 6.42442C2.81535 6.42098 2.81368 6.41867 2.81286 6.41753C2.81244 6.41696 2.81224 6.41668 2.81226 6.4167C2.81226 6.41671 2.81232 6.41679 2.81244 6.41695C2.81249 6.41703 2.81262 6.41721 2.81265 6.41725C2.81279 6.41744 2.81294 6.41765 2 7C1.18706 7.58235 1.18724 7.5826 1.18743 7.58287C1.18752 7.58298 1.18772 7.58327 1.18789 7.5835C1.18822 7.58397 1.18861 7.58451 1.18905 7.58512C1.18994 7.58635 1.19104 7.58789 1.19237 7.58972C1.19502 7.59339 1.19855 7.59825 1.20295 7.60427C1.21175 7.61631 1.22402 7.63299 1.23969 7.654C1.27102 7.696 1.31595 7.75537 1.37382 7.82961C1.4895 7.97801 1.65729 8.18642 1.87185 8.43486C2.29978 8.93037 2.91993 9.59233 3.68962 10.2569C5.19795 11.5592 7.42871 13 10 13V11ZM2 7C2.81294 7.58235 2.81279 7.58256 2.81265 7.58275C2.81262 7.58279 2.81249 7.58297 2.81244 7.58305C2.81232 7.58321 2.81226 7.58329 2.81226 7.5833C2.81224 7.58332 2.81244 7.58304 2.81286 7.58247C2.81368 7.58133 2.81535 7.57902 2.81787 7.57558C2.82289 7.5687 2.83127 7.5573 2.84292 7.54169C2.86621 7.51045 2.90254 7.4624 2.95124 7.39992C3.0487 7.27489 3.19525 7.09267 3.38551 6.87236C3.76722 6.43037 4.31864 5.84233 4.99668 5.2569C6.38378 4.05924 8.15301 3 10 3V1C7.42871 1 5.19795 2.44076 3.68962 3.7431C2.91993 4.40767 2.29978 5.06963 1.87185 5.56514C1.65729 5.81358 1.4895 6.02199 1.37382 6.17039C1.31595 6.24463 1.27102 6.304 1.23969 6.346C1.22402 6.36701 1.21175 6.38369 1.20295 6.39573C1.19855 6.40175 1.19502 6.40661 1.19237 6.41028C1.19104 6.41211 1.18994 6.41365 1.18905 6.41488C1.18861 6.41549 1.18822 6.41603 1.18789 6.4165C1.18772 6.41673 1.18752 6.41702 1.18743 6.41713C1.18724 6.4174 1.18706 6.41765 2 7ZM10 3C11.847 3 13.6162 4.05924 15.0033 5.2569C15.6814 5.84233 16.2328 6.43037 16.6145 6.87236C16.8048 7.09267 16.9513 7.27489 17.0488 7.39992C17.0975 7.4624 17.1338 7.51045 17.1571 7.54169C17.1687 7.5573 17.1771 7.5687 17.1821 7.57558C17.1846 7.57902 17.1863 7.58133 17.1871 7.58247C17.1876 7.58304 17.1878 7.58332 17.1877 7.5833C17.1877 7.58329 17.1877 7.58321 17.1876 7.58305C17.1875 7.58297 17.1874 7.58279 17.1874 7.58275C17.1872 7.58256 17.1871 7.58235 18 7C18.8129 6.41765 18.8128 6.4174 18.8126 6.41713C18.8125 6.41702 18.8123 6.41673 18.8121 6.4165C18.8118 6.41603 18.8114 6.41549 18.8109 6.41488C18.8101 6.41365 18.809 6.41211 18.8076 6.41028C18.805 6.40661 18.8014 6.40175 18.797 6.39573C18.7882 6.38369 18.776 6.36701 18.7603 6.346C18.729 6.304 18.684 6.24463 18.6262 6.17039C18.5105 6.02199 18.3427 5.81358 18.1281 5.56514C17.7002 5.06963 17.0801 4.40767 16.3104 3.7431C14.8021 2.44076 12.5713 1 10 1V3ZM12 6C12 7.10457 11.1046 8 10 8V10C12.2091 10 14 8.20914 14 6H12ZM10 8C8.89543 8 8 7.10457 8 6H6C6 8.20914 7.79086 10 10 10V8ZM8 6C8 4.89543 8.89543 4 10 4V2C7.79086 2 6 3.79086 6 6H8ZM10 4C11.1046 4 12 4.89543 12 6H14C14 3.79086 12.2091 2 10 2V4Z"
              fill="#8E9CBB"
            />
          </svg>

          <svg
            v-else
            class="c-input-icon-svg"
            width="20"
            height="12"
            viewBox="0 0 20 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6C18 6 14.4183 11 10 11C5.58172 11 2 6 2 6C2 6 5.58172 1 10 1C14.4183 1 18 6 18 6Z"
              stroke="#8E9CBB"
              stroke-width="2"
            />
            <path
              d="M13 5C13 6.65685 11.6569 8 10 8C8.34315 8 7 6.65685 7 5C7 3.34315 8.34315 2 10 2C11.6569 2 13 3.34315 13 5Z"
              stroke="#8E9CBB"
              stroke-width="2"
            />
          </svg>
        </div>

        <div
          v-if="displaySelectDatePeriodInput"
          class="c-input-value"
          :class="{
            'c-input-value_type_select': type === 'select',
            'c-input-value_placeholder': !selectValue,
            'c-input-value_type_select_clearable': clearable,
            'c-input-value_type_select_multiple': multiple,
            'c-input-value_size_small': size === 'small',
            'c-input-value_type_select_multiple_with_icon': multiple && checkboxType === 'icon',
            'c-input-value_type_select_multiple_without_checkbox': !checkbox && multiple,
          }"
          @click="openContainer"
        >
          <div v-if="!multiple && !withCategorized && type === 'select'" class="c-input-value-single">
            <span v-html="selectValue ? selectValue.resultLabel || selectValue.label || getLabel(selectValue) : placeholder"></span>
          </div>

          <div v-if="!multiple && withCategorized && type === 'select'" class="c-input-value-single">
            <span
              v-html="
                selectValue ? selectValue.resultLabel || selectValue.formatLabel || getLabel(selectValue) : placeholder
              "
            ></span>
          </div>

          <div v-if="multiple" class="c-input-value-multiple">
            <div
              v-if="!selectValue || selectValue.length === 0"
              class="c-input-value-placeholder"
              :class="{
                'c-input-value-placeholder-small': size === 'small',
              }"
            >
              {{ placeholder }}
            </div>

            <div
              v-for="(selectValueItem, selectValueItemIndex) in selectValue"
              :key="selectValueItem.value"
              class="c-input-value-multiple-item"
            >
              <div
                class="c-input-value-multiple-item-text"
                v-html="
                  selectValueItem.resultLabel ||
                    selectValueItem.formatLabel ||
                    selectValueItem.label ||
                    getLabel(selectValueItem)
                "
              ></div>
              <div class="c-input-value-multiple-item-close">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  xmlns="http://www.w3.org/2000/svg"
                  @click="(e) => dropItem(e, selectValueItemIndex)"
                >
                  <path
                    d="M0.325608 10.746C-0.0649162 10.3555 -0.0649162 9.72233 0.325608 9.33181L9.36312 0.292893C9.75364 -0.0976313 10.3868 -0.0976309 10.7773 0.292893C11.1679 0.683418 11.1679 1.31658 10.7773 1.70711L1.73982 10.746C1.3493 11.1365 0.716132 11.1365 0.325608 10.746Z"
                  />
                  <path
                    d="M10.6836 10.6835C11.0741 10.293 11.0741 9.65986 10.6836 9.26933L1.70711 0.292893C1.31658 -0.0976313 0.683417 -0.0976309 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L9.26935 10.6835C9.65987 11.0741 10.293 11.0741 10.6836 10.6835Z"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div
            v-if="(type === 'date' && !editable) || type === 'period' || type === 'period-without-fixed-intervals'"
            class="c-input-value-date"
            :class="{
              'c-input-value-date_placeholder': !dateValue,
              'c-input-value-date_size_small': size === 'small',
            }"
          >
            {{ dateValue ? dateValue : placeholder }}
          </div>
        </div>

        <input
          v-if="(!type || type === 'text' || type === 'password') && !mask && type !== 'number'"
          ref="text-input-element"
          v-model="textValue"
          class="c-input-input"
          :autocomplete="type === 'password' ? 'new-password' : 'off'"
          :maxlength="maxLength && Number(maxLength)"
          :class="{
            'c-input-input_placeholder_italic': placeholderStyle === 'italic',
            'c-input-input_size_small': size === 'small',
            'c-input-input-with-copy-to-clipboard': copiedToClipboard,
            'c-input-input_floating_label_active': textValue && floatingLabel,
          }"
          :disabled="disabled || type === 'select'"
          :type="type === 'password' && !passwordVisible ? 'password' : 'text'"
          :placeholder="placeholder"
          :pattern="pattern"
          @keydown="handleInputTextKeypressed"
          @keypress="handleInputTextKeypressed"
          @focus="handleInputFocus"
          @focusout="focused = false"
        />

        <input
          v-if="mask && type !== 'number'"
          v-model="textValue"
          v-mask="mask"
          class="c-input-input"
          :class="{
            'c-input-input_placeholder_italic': placeholderStyle === 'italic',
            'c-input-input_size_small': size === 'small',
          }"
          :disabled="type === 'select'"
          :type="type === undefined ? 'text' : 'text'"
          :placeholder="placeholder"
          @focus="focused = true"
          @focusout="focused = false"
        />

        <input
          v-if="type === 'number'"
          v-model.number="textValue"
          class="c-input-input c-input-input_type_number"
          :class="{
            'c-input-input_placeholder_italic': placeholderStyle === 'italic',
            'c-input-input_size_small': size === 'small',
          }"
          type="number"
          :placeholder="placeholder"
          :pattern="pattern"
          :maxlength="maxLength && Number(maxLength)"
          @keypress="handleInputNumberKeypressed"
          @focus="focused = true"
          @focusout="focused = false"
        />

        <input
          v-if="type === 'price-number'"
          v-model="textValue"
          class="c-input-input c-input-input_type_number"
          :class="{
            'c-input-input_placeholder_italic': placeholderStyle === 'italic',
            'c-input-input_size_small': size === 'small',
            'c-input-input_floating_label_active': '' + textValue && floatingLabel,
          }"
          :maxlength="maxLength && Number(maxLength)"
          type="text"
          :placeholder="placeholder"
          @keypress="handleInputPriceKeypressed"
          @focus="focused = true"
          @focusout="focused = false"
        />

        <input
          v-if="type === 'integer-number'"
          v-model="textValue"
          class="c-input-input c-input-input_type_number"
          :class="{
            'c-input-input_placeholder_italic': placeholderStyle === 'italic',
            'c-input-input_size_small': size === 'small',
            'c-input-input_floating_label_active': '' + textValue && floatingLabel,
            'ml-22': prependArrow,
          }"
          type="number"
          :maxlength="maxLength && Number(maxLength)"
          :placeholder="placeholder"
          @paste.prevent
          @keypress="handleInputIntegerNumberKeypressed"
          @focus="focused = true"
          @focusout="focused = false"
        />

        <div
          v-if="type === 'textarea'"
          class="c-input-textarea c-input-input"
          :class="{ 'c-input-textarea-clearable': clearable }"
          :style="{ 'max-height': `${textareaMaxHeight}px` }"
        >
          <div
            ref="textareaValue"
            contenteditable
            class="c-input-textarea-value"
            :style="{
              'max-height': `${textareaMaxHeight}px`,
              'overflow': 'hidden',
            }"
            @focus="focused = true"
            @focusout="focused = false"
            @keydown="checkTextareaInputSize"
            @paste="checkTextareaInputSize"
            @input="onInput"
          ></div>

          <div v-if="textValue === ''" class="c-input-textarea-placeholder">
            {{ placeholder }}
          </div>
        </div>
        
        <div
          v-if="floatingLabel"
          class="c-input-floating-label"
          :class="{
            'c-input-floating-label-active':
              (isArray(selectValue) && selectValue.length !== 0) || (!isArray(selectValue) && selectValue) || (type === 'textarea' && (focused || textValue)),
            'c-input-floating-label-pr': !multiple && !container,
          }"
        >
          {{ floatingLabel }}
          <span v-if="requiredMark" class="c-input-label__required">*</span>
          <div v-if="labelFullName" class="c-input-label-fullname">
            <c-button
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover',
                content: labelFullName,
                placement: 'bottom',
              }"
              size="iconic"
              icon="info"
            />
          </div>
        </div>

        <input
          v-if="type === 'date' && editable"
          ref="inputdateeditable"
          v-model="textValue"
          v-mask="'##.##.####'"
          class="c-input-input c-input-input_date"
          :class="{
            'c-input-input_placeholder_italic': placeholderStyle === 'italic',
            'c-input-input_size_small': size === 'small',
          }"
          placeholder="00.00.0000"
          @focus="focused = true"
        />

        <div
          v-if="!checkbox || type === 'date' || type === undefined"
          class="c-input-actions"
          :class="{
            'c-input-actions_size_small': size === 'small',
          }"
        >
          <div
            v-if="clearable"
            class="c-input-action c-input-action_clear"
            :class="{
              'c-input-action_clear_active': (multiple ? !!selectValue.length : !!selectValue) || dateValue || textValue,
            }"
          >
            <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" @click="clear">
              <path
                d="M0.325608 10.746C-0.0649162 10.3555 -0.0649162 9.72233 0.325608 9.33181L9.36312 0.292893C9.75364 -0.0976313 10.3868 -0.0976309 10.7773 0.292893C11.1679 0.683418 11.1679 1.31658 10.7773 1.70711L1.73982 10.746C1.3493 11.1365 0.716132 11.1365 0.325608 10.746Z"
              />
              <path
                d="M10.6836 10.6835C11.0741 10.293 11.0741 9.65986 10.6836 9.26933L1.70711 0.292893C1.31658 -0.0976313 0.683417 -0.0976309 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L9.26935 10.6835C9.65987 11.0741 10.293 11.0741 10.6836 10.6835Z"
              />
            </svg>
          </div>

          <div
            v-if="type === 'text' && copiedToClipboard"
            class="c-input-action c-input-action_copy_to_clipboard"
            :class="{ 'c-input-action_arrow_active': container }"
          >
            <c-button
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover blur',
                content: 'Скопировать в буфер',
                placement: 'top',
              }"
              icon="copy-to-clipboard"
              :disabled="!textValue"
              size="iconic"
              @click="copyToClipboard"
            />
            <input v-if="copiedToClipboard" id="copy-to-clipboard-hidden-input" type="hidden" :value="textValue" />
          </div>

          <div
            v-if="type === 'select'"
            class="c-input-action c-input-action_arrow"
            :class="{ 'c-input-action_arrow_active': container }"
          >
            <svg
              class="c-input-action-arrow"
              width="12"
              height="7"
              viewBox="0 0 12 7"
              xmlns="http://www.w3.org/2000/svg"
              @click="openContainer"
            >
              <path
                d="M5.30964 6.70905C4.92189 6.32111 4.92189 5.69215 5.30964 5.30421L10.305 0.306472C10.6928 -0.0814626 11.3214 -0.081462 11.7092 0.306473C12.0969 0.694408 12.0969 1.32337 11.7092 1.71131L6.71381 6.70905C6.32606 7.09698 5.69739 7.09698 5.30964 6.70905Z"
              />
              <path
                d="M6.70587 6.70905C7.09363 6.32111 7.09363 5.69215 6.70587 5.30421L1.69498 0.290951C1.30723 -0.096984 0.678565 -0.0969834 0.290814 0.290951C-0.0969378 0.678886 -0.0969378 1.30785 0.290814 1.69579L5.3017 6.70905C5.68946 7.09698 6.31812 7.09698 6.70587 6.70905Z"
              />
            </svg>
          </div>
        </div>

        <div
          v-if="checkbox"
          class="c-input-checkbox"
          :class="{ 'c-input-checkbox-type-icon': checkboxType === 'icon' }"
        >
          <c-switcher
            v-if="!checkboxType"
            v-model="checkboxValueLocal"
            :label="{
              text: checkbox.text ? checkbox.text : checkbox,
              color: checkbox.labelColor ? checkbox.labelColor : null,
            }"
            :disabled="value.length === -1"
            type="checkbox"
            :nowrap="true"
          />

          <c-switcher
            v-if="checkboxType === 'icon'"
            v-model="checkboxValueLocal"
            type="checkbox-icon"
            :disabled="value.length === -1"
            :tooltip="checkboxTooltip"
          />
        </div>

        <div
          class="c-input-border"
          :class="{
            'c-input-border_active': focused || container,
            'c-input-border-pink':
              invalid ||
              inputTextCondition ||
              requiredMessage ||
              computedErrors.length > 0 ||
              (requiredCondition && required) ||
              (required && type === 'date'),
          }"
        ></div>
      </div>

      <div
        v-if="actuallyNormalErrorMessages"
        v-show="computedErrors.length > 0"
        class="error-messages"
      >
        <div class="error-messages__icon">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D" />
            <circle cx="7" cy="10" r="1" fill="#FF238D" />
            <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D" />
          </svg>
        </div>
        <div class="error-messages__list">
          <div
            v-for="(message, messageIndex) in computedErrors"
            :key="`err_${messageIndex}`"
            class="error-messages__item"
          >
            {{ message }}
          </div>
        </div>
      </div>
      <div v-else-if="computedErrors.length > 0" class="c-input-required 5 c-input-required_active">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D" />
          <circle cx="7" cy="10" r="1" fill="#FF238D" />
          <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D" />
        </svg>

        <div class="c-input-required-text">{{ computedErrors.join("; ") }}</div>
      </div>

      <div
        v-if="required"
        class="c-input-required 1"
        :class="{
          'c-input-required_active':
            !type || ['date', 'password', 'period', 'period-without-fixed-intervals', 'text', 'number'].includes(type),
        }"
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D" />
          <circle cx="7" cy="10" r="1" fill="#FF238D" />
          <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D" />
        </svg>

        <div class="c-input-required-text">{{ required }}</div>
      </div>

      <div
        v-if="inputTextCondition"
        class="c-input-required c-input-required_active 2"
        :class="{ 'c-input-required_active': value.length < 3 }"
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D" />
          <circle cx="7" cy="10" r="1" fill="#FF238D" />
          <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D" />
        </svg>

        <div class="c-input-required-text">{{ inputTextCondition }}</div>
      </div>

      <div
        v-if="required && requiredCondition"
        class="c-input-required 3"
        :class="{
          'c-input-required_active':
            (type === 'select') || type === 'integer-number' || type === 'price-number',
        }"
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D" />
          <circle cx="7" cy="10" r="1" fill="#FF238D" />
          <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D" />
        </svg>

        <div class="c-input-required-text">{{ required }}</div>
      </div>

      <div
        v-if="type === 'select' || type === 'date' || type === 'period' || type === 'period-without-fixed-intervals'"
        ref="inputContainer"
        class="c-input-container"
        :class="{
          'c-input-container_active': containerActive,
          'c-input-container_date': type === 'date',
          'c-input-container_period': type === 'period',
          'c-input-container_period-without-fixed-intervals': type === 'period-without-fixed-intervals',
          'c-input-container_size_small': size === 'small',
          'c-input-container_nolabel': !label && !floatingLabel,
          'c-input-container_right': this.correctPositionContainer && this.correctPositionContainer === 'right',
          'c-input-container_left': this.correctPositionContainer && this.correctPositionContainer === 'left',
        }"
      >
        <div
          v-if="type === 'period' || type === 'period-without-fixed-intervals' || type === 'date'"
          class="c-input-container-close"
          @click="closeContainer"
        >
          <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
              fill="#8E9CBB"
            />
            <path
              d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
              fill="#8E9CBB"
            />
          </svg>
        </div>

        <div
          v-if="searchable"
          class="c-input-container-search"
          :class="{
            'c-input-container-search-with-special-value': withSpecialValue,
          }"
        >
          <div class="c-input-container-search-icon">
            <svg width="13" height="13" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.4142 11L15.6569 15.2426M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>

          <input v-model="selectSearch" class="c-input-container-search-input" type="text" placeholder="Поиск" />

          <div v-if="selectSearch.length > 0" class="c-input-container-search-icon-clear" @click="selectSearch = ''">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.325608 10.746C-0.0649162 10.3555 -0.0649162 9.72233 0.325608 9.33181L9.36312 0.292893C9.75364 -0.0976313 10.3868 -0.0976309 10.7773 0.292893C11.1679 0.683418 11.1679 1.31658 10.7773 1.70711L1.73982 10.746C1.3493 11.1365 0.716132 11.1365 0.325608 10.746Z"
                fill="#FF238D"
              ></path>
              <path
                d="M10.6836 10.6835C11.0741 10.293 11.0741 9.65986 10.6836 9.26933L1.70711 0.292893C1.31658 -0.0976313 0.683417 -0.0976309 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L9.26935 10.6835C9.65987 11.0741 10.293 11.0741 10.6836 10.6835Z"
                fill="#FF238D"
              ></path>
            </svg>
          </div>

          <div class="c-input-container-search-border"></div>
        </div>

        <div
          v-if="type === 'select'"
          class="c-input-container-list"
          :class="{ 'c-input-container-list-active': !multiple }"
        >
          <div
            v-if="selectSearchEmpty"
            class="c-input-container-list-item c-input-container-list-item_empty"
            :class="{
              'c-input-container-list-item_empty_size_small': size === 'small',
            }"
          >
            Совпадений не найдено
          </div>

          <div
            v-else-if="!selectItems || !selectItems.length"
            class="c-input-container-list-item c-input-container-list-item_empty"
            :class="{
              'c-input-container-list-item_empty_size_small': size === 'small',
            }"
          >
            Справочник значений пустой
          </div>

          <div
            v-for="item in selectItems"
            :key="item.value"
            class="c-input-container-list-item"
            :class="{
              'c-input-container-list-item_disabled': isItemDisabled(item),
              'c-input-container-list-item_with_avatar': item.avatar && itemsWithAvatar,
              'c-input-container-list-item_selected': item === selectValue,
              'c-input-container-list-item_special': item.specialValue !== undefined && item.specialValue,
              'c-input-container-list-item_category': withCategorized && !item.isSubCategory,
              'c-input-container-list-item_subcategory': withCategorized && item.isSubCategory,
            }"
            :style="{
              'margin-left': item.level * 10 + 'px',
            }"
            @click="(e) => selectItem(e, item)"
          >
            <div
              v-if="item.avatar && itemsWithAvatar"
              class="c-input-container-list-item-avatar"
              :style="{ backgroundImage: `url(${item.avatar})` }"
            ></div>

            <div
              class="c-input-container-list-item-label"
              :class="{
                'c-input-container-list-item-label-bold': item.specialValue !== undefined && item.specialValue,
              }"
            >
              <span v-html="item.formatLabel || item.label"></span>
              <div v-if="item.subLabel" class="list-item-sublabel 2">
                {{ item.subLabel }}
              </div>
            </div>
            <div
              v-if="item.specialValue !== undefined && item.specialValue"
              class="c-input-container-list-item-border"
            ></div>
          </div>
        </div>

        <div v-if="type === 'select' && multiple" class="c-input-container-list c-input-container-list-mobile">
          <div
            v-if="selectSearchEmpty"
            class="c-input-container-list-item c-input-container-list-item_empty"
            :class="{
              'c-input-container-list-item_empty_size_small': size === 'small',
            }"
          >
            Совпадений не найдено
          </div>
          <div
            v-else-if="!selectItems || !selectItems.length"
            class="c-input-container-list-item c-input-container-list-item_empty"
            :class="{
              'c-input-container-list-item_empty_size_small': size === 'small',
            }"
          >
            Справочник значений пустой
          </div>
          <div
            v-for="item in selectItems"
            :key="item.value"
            class="c-input-container-list-item"
            :class="{ 'c-input-container-list-item_with_avatar': item.avatar && itemsWithAvatar }"
          >
            <c-switcher
              :id="item.value"
              v-model="checkedMobileMultipleSelects"
              :label="{
                text: item.label,
                color: null,
              }"
              type="checkbox"
              :value="item"
              :checked="item"
              :multi="true"
              :nowrap="true"
            />
          </div>
        </div>

        <div v-if="type === 'select'" class="c-input-container-list-mobile-buttons">
          <c-button
            class="c-input-container-list-mobile-buttons-cancel"
            size="small"
            label="Отмена"
            @click="closeContainer"
          />
          <c-button v-if="multiple" size="small" label="Готово" color="primary" @click="selectItemsMobileMultiple" />
        </div>

        <div
          v-if="type === 'date'"
          class="c-input-container-date"
          :class="{
            'with-selects': selects,
          }"
        >
          <div v-if="selects" class="selects">
            <c-select v-model="year" class="year" :items="years" :scroll-to-selected="true" />
            <c-select v-model="month" class="month" :items="months" />
          </div>

          <datepicker
            ref="inputTypeDateDatepicker"
            v-model="selectedDate"
            :open-date="selects ? openDate : null"
            :inline="true"
            :language="ru"
            :full-month-name="true"
            :monday-first="true"
            calendar-class="c-input-container-calendar"
            @selected="closeContainerDatepickerContainer"
          />

          <div class="c-input-container-date-actions-mobile">
            <div class="c-input-container-date-actions-mobile-item" @click="dateReset">Сбросить</div>
            <div class="c-input-container-date-actions-mobile-item" @click="dateSubmit">Применить</div>
          </div>
        </div>

        <div v-if="type === 'period'" class="c-input-container-period">
          <div class="c-input-container-period-actions-mobile">
            <div class="c-input-container-period-actions-mobile-item" @click="periodReset">Сбросить</div>
            <div class="c-input-container-period-actions-mobile-item" @click="periodSubmit">Применить</div>
          </div>

          <div
            class="c-input-container-period-calendars"
            :class="{ 'c-input-container-period-calendars_disabled': false }"
          >
            <div
              class="c-input-container-period-calendars-item"
              :class="{
                'c-input-container-period-calendars-item_active':
                  period.activeCalendar === 'start' && container !== false,
              }"
            >
              <div
                :class="{
                  'c-input-container-period-input-wrapper-required': isNotValidPeriodDateStart(),
                }"
                class="c-input-container-period-input-wrapper"
              >
                <the-mask
                  v-model="period.start.input"
                  mask="##.##.####"
                  class="c-input-container-period-input"
                  type="text"
                  placeholder="00.00.0000"
                  :masked="true"
                />

                <div class="c-input-container-period-input-icon">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z"
                      stroke="#8E9CBB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13 1V5"
                      stroke="#8E9CBB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path d="M5 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <rect x="4" y="8" width="2" height="2" fill="#8E9CBB" />
                    <rect x="4" y="12" width="2" height="2" fill="#8E9CBB" />
                    <rect x="8" y="8" width="2" height="2" fill="#8E9CBB" />
                    <rect x="8" y="12" width="2" height="2" fill="#8E9CBB" />
                    <rect x="12" y="8" width="2" height="2" fill="#8E9CBB" />
                    <rect x="12" y="12" width="2" height="2" fill="#8E9CBB" />
                  </svg>
                </div>
              </div>

              <div class="c-input-container-period-calendar">
                <datepicker
                  v-model="period.start.selected"
                  :inline="true"
                  :language="ru"
                  :full-month-name="true"
                  :monday-first="true"
                  :highlighted="{
                    from: period.start.highlighted,
                    to: period.end.highlighted,
                  }"
                  :open-date="period.startMonth"
                  calendar-class="c-input-container-calendar c-input-container-calendar_period"
                  @changedMonth="changedStartMonth"
                  @selected="periodSelectDay"
                />
              </div>
            </div>

            <div
              class="c-input-container-period-calendars-item"
              :class="{
                'c-input-container-period-calendars-item_active':
                  period.activeCalendar === 'end' && container !== false,
              }"
            >
              <div
                :class="{
                  'c-input-container-period-input-wrapper-required': isNotValidPeriodDateEnd(),
                }"
                class="c-input-container-period-input-wrapper"
              >
                <the-mask
                  v-model="period.end.input"
                  mask="##.##.####"
                  class="c-input-container-period-input"
                  type="text"
                  placeholder="00.00.0000"
                  :masked="true"
                />

                <div class="c-input-container-period-input-icon">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z"
                      stroke="#8E9CBB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13 1V5"
                      stroke="#8E9CBB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path d="M5 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <rect x="4" y="8" width="2" height="2" fill="#8E9CBB" />
                    <rect x="4" y="12" width="2" height="2" fill="#8E9CBB" />
                    <rect x="8" y="8" width="2" height="2" fill="#8E9CBB" />
                    <rect x="8" y="12" width="2" height="2" fill="#8E9CBB" />
                    <rect x="12" y="8" width="2" height="2" fill="#8E9CBB" />
                    <rect x="12" y="12" width="2" height="2" fill="#8E9CBB" />
                  </svg>
                </div>
              </div>

              <div class="c-input-container-period-calendar">
                <datepicker
                  v-model="period.end.selected"
                  :inline="true"
                  :language="ru"
                  :full-month-name="true"
                  :monday-first="true"
                  :highlighted="{
                    from: period.start.highlighted,
                    to: period.end.highlighted,
                  }"
                  :open-date="period.endMonth"
                  calendar-class="c-input-container-calendar c-input-container-calendar_period"
                  @changedMonth="changedEndMonth"
                  @selected="periodSelectDay"
                />
              </div>
            </div>
          </div>

          <div class="c-input-container-period-switcher">
            <div
              class="c-input-container-period-switcher-item"
              :class="{
                'c-input-container-period-switcher-item_active': period.activeCalendar === 'start',
              }"
              @click="period.activeCalendar = 'start'"
            >
              <span>Начало периода</span>
            </div>

            <div
              class="c-input-container-period-switcher-item"
              :class="{
                'c-input-container-period-switcher-item_active': period.activeCalendar === 'end',
              }"
              @click="period.activeCalendar = 'end'"
            >
              <span>Конец периода</span>
            </div>
          </div>

          <div class="c-input-container-period-right">
            <div class="c-input-container-period-links">
              <div
                class="c-input-container-period-link"
                :class="{
                  'c-input-container-period-link_active': period.range === 'yesterday',
                }"
                @click="period.range = 'yesterday'"
              >
                Вчера
              </div>
              <div
                class="c-input-container-period-link"
                :class="{
                  'c-input-container-period-link_active': period.range === 'today',
                }"
                @click="period.range = 'today'"
              >
                Сегодня
              </div>
              <div
                class="c-input-container-period-link"
                :class="{
                  'c-input-container-period-link_active': period.range === 'begin-week',
                }"
                @click="period.range = 'begin-week'"
              >
                C начала недели
              </div>
              <div
                class="c-input-container-period-link"
                :class="{
                  'c-input-container-period-link_active': period.range === 'past-week',
                }"
                @click="period.range = 'past-week'"
              >
                Прошлая неделя
              </div>
              <div
                class="c-input-container-period-link"
                :class="{
                  'c-input-container-period-link_active': period.range === 'last-7-days',
                }"
                @click="period.range = 'last-7-days'"
              >
                Последние 7 дней
              </div>
              <div
                class="c-input-container-period-link"
                :class="{
                  'c-input-container-period-link_active': period.range === 'current-month',
                }"
                @click="period.range = 'current-month'"
              >
                Текущий месяц
              </div>
              <div
                class="c-input-container-period-link"
                :class="{
                  'c-input-container-period-link_active': period.range === 'past-month',
                }"
                @click="period.range = 'past-month'"
              >
                Прошлый месяц
              </div>
              <div
                class="c-input-container-period-link"
                :class="{
                  'c-input-container-period-link_active': period.range === 'last-month',
                }"
                @click="period.range = 'last-month'"
              >
                Последний месяц
              </div>
              <div
                class="c-input-container-period-link"
                :class="{
                  'c-input-container-period-link_active': period.range === 'custom',
                }"
                @click="period.range = 'custom'"
              >
                Произвольный период
              </div>
            </div>

            <div class="c-input-container-period-actions">
              <c-button
                class="c-input-container-period-action"
                size="small"
                label="Применить"
                :icon="{ icon: 'check', color: 'success' }"
                @click="periodSubmit"
              />

              <c-button
                class="c-input-container-period-action"
                size="small"
                label="Сбросить"
                :icon="{ icon: 'close', color: 'secondary' }"
                @click="periodReset"
              />
            </div>
          </div>
        </div>

        <div
          v-if="type === 'period-without-fixed-intervals'"
          class="c-input-container-period c-input-container-period-without-fixed-intervals"
        >
          <div class="c-input-container-period-actions-mobile">
            <div class="c-input-container-period-actions-mobile-item" @click="periodReset">Сбросить</div>
            <div class="c-input-container-period-actions-mobile-item" @click="periodSubmit">Применить</div>
          </div>

          <div
            class="c-input-container-period-calendars"
            :class="{ 'c-input-container-period-calendars_disabled': false }"
          >
            <div
              class="c-input-container-period-calendars-item"
              :class="{
                'c-input-container-period-calendars-item_active':
                  period.activeCalendar === 'start' && container !== false,
              }"
            >
              <div
                :class="{
                  'c-input-container-period-input-wrapper-required': isNotValidPeriodDateStart(),
                }"
                class="c-input-container-period-input-wrapper"
              >
                <the-mask
                  v-model="period.start.input"
                  mask="##.##.####"
                  class="c-input-container-period-input"
                  type="text"
                  placeholder="00.00.0000"
                  :masked="true"
                />

                <div class="c-input-container-period-input-icon">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z"
                      stroke="#8E9CBB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13 1V5"
                      stroke="#8E9CBB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path d="M5 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <rect x="4" y="8" width="2" height="2" fill="#8E9CBB" />
                    <rect x="4" y="12" width="2" height="2" fill="#8E9CBB" />
                    <rect x="8" y="8" width="2" height="2" fill="#8E9CBB" />
                    <rect x="8" y="12" width="2" height="2" fill="#8E9CBB" />
                    <rect x="12" y="8" width="2" height="2" fill="#8E9CBB" />
                    <rect x="12" y="12" width="2" height="2" fill="#8E9CBB" />
                  </svg>
                </div>
              </div>

              <div class="c-input-container-period-calendar">
                <datepicker
                  v-model="period.start.selected"
                  :inline="true"
                  :language="ru"
                  :full-month-name="true"
                  :monday-first="true"
                  :selects="selects"
                  :highlighted="{
                    from: period.start.highlighted,
                    to: period.end.highlighted,
                  }"
                  :open-date="period.startMonth"
                  calendar-class="c-input-container-calendar c-input-container-calendar_period c-input-container-calendar_period-without-fixed-intervals"
                  @changedMonth="changedStartMonth"
                  @selected="periodSelectDay"
                />
              </div>
            </div>

            <div
              class="c-input-container-period-calendars-item"
              :class="{
                'c-input-container-period-calendars-item_active':
                  period.activeCalendar === 'end' && container !== false,
              }"
            >
              <div
                :class="{
                  'c-input-container-period-input-wrapper-required': isNotValidPeriodDateEnd(),
                }"
                class="c-input-container-period-input-wrapper"
              >
                <the-mask
                  v-model="period.end.input"
                  mask="##.##.####"
                  class="c-input-container-period-input"
                  type="text"
                  placeholder="00.00.0000"
                  :masked="true"
                />

                <div class="c-input-container-period-input-icon">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z"
                      stroke="#8E9CBB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13 1V5"
                      stroke="#8E9CBB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path d="M5 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <rect x="4" y="8" width="2" height="2" fill="#8E9CBB" />
                    <rect x="4" y="12" width="2" height="2" fill="#8E9CBB" />
                    <rect x="8" y="8" width="2" height="2" fill="#8E9CBB" />
                    <rect x="8" y="12" width="2" height="2" fill="#8E9CBB" />
                    <rect x="12" y="8" width="2" height="2" fill="#8E9CBB" />
                    <rect x="12" y="12" width="2" height="2" fill="#8E9CBB" />
                  </svg>
                </div>
              </div>

              <div class="c-input-container-period-calendar">
                <datepicker
                  v-model="period.end.selected"
                  :inline="true"
                  :language="ru"
                  :full-month-name="true"
                  :monday-first="true"
                  :highlighted="{
                    from: period.start.highlighted,
                    to: period.end.highlighted,
                  }"
                  :open-date="period.endMonth"
                  calendar-class="c-input-container-calendar c-input-container-calendar_period c-input-container-calendar_period-without-fixed-intervals"
                  @changedMonth="changedEndMonth"
                  @selected="periodSelectDay"
                />
              </div>
            </div>
          </div>

          <div class="c-input-container-period-switcher">
            <div
              class="c-input-container-period-switcher-item"
              :class="{
                'c-input-container-period-switcher-item_active': period.activeCalendar === 'start',
              }"
              @click="period.activeCalendar = 'start'"
            >
              <span>Начало периода</span>
            </div>

            <div
              class="c-input-container-period-switcher-item"
              :class="{
                'c-input-container-period-switcher-item_active': period.activeCalendar === 'end',
              }"
              @click="period.activeCalendar = 'end'"
            >
              <span>Конец периода</span>
            </div>
          </div>

          <div class="c-input-container-period-right">
            <div class="c-input-container-period-actions">
              <c-button
                class="c-input-container-period-action"
                size="small"
                label="Применить"
                :icon="{ icon: 'check', color: 'success' }"
                @click="periodSubmit"
              />

              <c-button
                class="c-input-container-period-action"
                size="small"
                label="Сбросить"
                :icon="{ icon: 'close', color: 'secondary' }"
                @click="periodReset"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

import { createPopper } from "@popperjs/core";
import Datepicker from "vuejs-datepicker";
import { ru } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import { TheMask, mask } from "vue-the-mask";

import CSelect from "@/components/controls2/Select";
import Switcher from "@/components/controls/switcher";
import Button from "@/components/controls2/Button";

import { divideNumberIntoClasses } from "@/utils/number/format";
import { MONTHS } from "@/utils/date/months";

const months = MONTHS.map((m, i) => ({ value: i, label: m }));

const now = new Date();

const year = now.getFullYear();
const month = now.getMonth();

const start = year - 100;

const years = Array(150)
  .fill(null)
  .map((_, i) => ({
    value: i + start,
    label: i + start,
  }));
const currentYear = { value: year, label: year };
const currentMonth = months.find((m) => m.value === month);

export default {
  name: "c-input",

  components: {
    "c-switcher": Switcher,
    "c-button": Button,
    TheMask,
    Datepicker,
    CSelect,
  },

  directives: { mask, ClickOutside },

  props: [
    "flip",

    "value",
    "type",
    "label",
    "floatingLabel",
    "labelFullName",
    "size",
    "required",
    "requiredMark",
    "requiredCondition",
    "requiredMessage",
    "inputTextCondition",
    "textareaMaxHeight",
    "textareaMaxLength",

    "withSpecialValue",
    "withCategorized",

    "disabled",

    "placeholder",
    "placeholderStyle",
    "clearable",

    "icon",
    "iconRight",

    "maxIntegerValue",

    "copiedToClipboard",
    "editable",

    // селекты месяца и года
    "selects",
    "defaultYear",

    // Пропы селекта
    "items",
    "multiple",
    "searchable",
    "removeSelected",
    "itemsWithAvatar",
    "disabledValues",

    "checkbox",
    "checkboxValue",
    "checkboxType",
    "checkboxTooltip",

    "format",

    "mask",
    "maxLength",
    "pattern",

    "fractionalLength",
    "allowNegative",
    "prependArrow",

    "split",
    "autofocus",

    "invalid",
    "error",

    "actually-normal-error-messages",
  ],

  data() {
    return {
      ru,
      localError: "",

      textValue:
        !this.type ||
        this.type === "text" ||
        this.type === "password" ||
        this.type === "number" ||
        this.type === "integer-number"
          ? this.value
          : "",
      selectValue: this.type === "select" ? this.value : null,

      container: false,
      correctPositionContainer: "",

      passwordVisible: false,

      selectSearch: "",
      selectSearchEmpty: false,

      selectItems: this.items,

      dateValue: "",
      selectedDate: null,

      focused: false,

      checkboxValueLocal: false,

      checkedMobileMultipleSelects: [],

      months,
      month: currentMonth,
      years,
      year: this.defaultYear ? { label: this.defaultYear, value: this.defaultYear } : currentYear,

      period: {
        setPeriodFlag: false,
        submitAttempt: false,
        range: "",
        start: {
          input: "",
          selected: null,
          value: null,
          highlighted: null,
        },
        end: {
          input: "",
          selected: null,
          value: null,
          highlighted: null,
        },
        startMonth: null,
        endMonth: null,
        activeCalendar: "start",
      },
    };
  },
  computed: {
    displaySelectDatePeriodInput() {
      return (
        this.type === "select" ||
        (this.type === "date" && !this.editable) ||
        this.type === "period" ||
        this.type === "period-without-fixed-intervals"
      );
    },
    openDate() {
      if (!this.selects) return null;
      return new Date(this.year.value, this.month.value);
    },
    containerActive() {
      const isActive = this.container || this.focused;

      return isActive;
    },
    computedErrors () {
      let errors = this.error || this.localError || [];

      if (!Array.isArray(errors)) {
        errors = [errors];
      }

      return errors;
    },
  },

  watch: {
    "containerActive": function (value) {
      if (this.type === "date") {
        if (value) {
          this.savedDate = this.selectedDate;
        } else {

          // let dateArray = this.textValue.split(".");
          // let dateString = dateArray[1] + '.' + dateArray[0] + '.' + dateArray[2];
          this.selectedDate = this.savedDate;
          this.textValue = moment(this.selectedDate).format("DD.MM.YYYY");
        
          // if (isNaN(Date.parse(this.savedDate))) {
          //   this.localError = "Неверно указана дата"
          //   this.$emit('date-validity-check', false)
          // } else {
          //   this.localError = "";
          //   this.selectedDate = this.savedDate;
          //   this.$emit('date-validity-check', true)
          // }
        }
      }
    },
    "checkboxValue": function (value) {
      this.checkboxValueLocal = value;
    },

    "checkboxValueLocal": function (value) {
      this.$emit("checkboxChange", value, this.label);
    },

    "period.start.input": function (value) {
      if (value.length === 10) {
        const splitted = value.split(".");

        this.period.start.highlighted = moment(`${splitted[2]}-${splitted[1]}-${splitted[0]}`).toDate();
      }

      if (this.period.range !== "custom" && !this.period.setPeriodFlag) {
        this.period.range = "custom";
      }
    },

    "period.end.input": function (value) {
      if (value.length === 10) {
        const splitted = value.split(".");

        this.period.end.highlighted = moment(`${splitted[2]}-${splitted[1]}-${splitted[0]}`).toDate();
      }

      if (this.period.range !== "custom" && !this.period.setPeriodFlag) {
        this.period.range = "custom";
      }
    },

    "period.range": function (value) {
      this.setPeriod(value);
    },

    "items": function (value) {
      if (this.type === "select") {
        this.selectItems = value;
      }
    },

    "dateValue": function (value) {
      this.$emit("input", value);

      if (value) {
        const date = moment(value, "DD.MM.YYYY");

        if (date.isValid()) {
          this.month = { value: date.month() };
          const year = date.year();

          this.year = { value: year, label: year };
        }
      } else {
        this.month = currentMonth;
        this.year = this.defaultYear ? { value: this.defaultYear, label: this.defaultYear } : currentYear;
      }
    },

    "selectValue": function (value) {
      this.$emit("input", value);
    },

    "textValue": function (value) {
      if (this.type !== "date") {
        if (this.split) {
          this.$emit("input", value.toString().replace(/\s/g, ""));
        } else {
          this.$emit("input", value);
        }
      } else {
        if (this.editable) {
          this.$emit("input", value);
        }

        if (value && value.length === 10) {
          let date = value.split(".");
          date = `${date[2]}-${date[1]}-${date[0]}`;

          if (moment(date).isValid()) {
            this.selectedDate = moment(date).toDate();
            this.$emit("invalidDate", "");
          } else {
            this.$emit("invalidDate", "Неверно указана дата");
          }
        } else {
          this.$emit("invalidDate", "Обязательное поле");
        }
      }
    },

    "selectSearch": function (value) {
      if (this.type === "select" && this.items) {
        const items = this.items.map((item) => item);

        const searched = items.filter((i) => {
          if (!i.label) {
            return false;
          }
          return i.label.toString().toLowerCase().includes(value.toString().toLowerCase());
        });

        this.selectSearchEmpty = searched.length === 0;

        this.selectItems = searched;
      }
    },

    "selectedDate": function (value) {
      this.container = false;
      this.dateValue = moment(value).format("DD.MM.YYYY");

      if (this.editable) {
        this.textValue = moment(value).format("DD.MM.YYYY");
        this.savedDate = value;
      }
    },

    "value": function (value) {
      this.setValue(value);
    },
    "focused": function (v) {
      this.$nextTick(() => {
        this.$emit(v ? "focus" : "blur");
      });
    },
  },

  created () {
    if (this.type === "date") {
      if (this.value) {
        this.dateValue = this.value;
        this.textValue = this.value;
      }
    } else this.setValue(this.value);
    this.checkboxValueLocal = this.checkboxValue;

    if (this.type === 'textarea') {
      let flag = true;
      setTimeout(() => {
        document.querySelectorAll("div[contenteditable]").forEach(textarea => {
          textarea.addEventListener("paste", function(e) {
            if (flag) {
              e.preventDefault();
              var text = e.clipboardData.getData("text/plain");
              document.execCommand("insertHTML", false, text);
              flag = !flag
            }
          });
        })
      }, 1000);
    }
  },

  mounted() {
    if (this.type === "period" || this.type === "period-without-fixed-intervals") {
      this.period.range = "custom";

      const today = moment().startOf("month");

      this.period.startMonth = moment(today).subtract(1, "month").toDate();
      this.period.endMonth = moment(today).toDate();
    }

    if (this.autofocus) this.focusOnInput();

    const $input = this.$el.querySelector(".c-input");
    const $container = this.$el.querySelector(".c-input-container");

    let cb = (e) => {
      if (!this.container) return;
      const $container = this.$el.querySelector(".c-input-container");
      if ($input && $input.contains(e.target)) return;
      if ($container && $container.contains(e.target)) return;

      this.closeContainer();
    };
    document.addEventListener("click", cb);

    this.$emit("mounted");

    if (this.flip && $container) {
      this._popper = createPopper($input, $container, {
        placement: "bottom-start",
        modifiers: [
          {
            name: "flip",
            options: {
              fallbackPlacements: ["bottom-end"],
            },
          },
        ],
      });
    }

    this._onDestroy = () => {
      document.removeEventListener("click", cb);
      cb = null;

      if (this._popper) {
        this._popper.destroy();
      }
    };
  },

  beforeDestroy() {
    this._onDestroy();
  },

  methods: {
    setValue(value) {
      if (this.type === "select") {
        this.selectValue = value;
      } else if (this.type === "period" || this.type === "period-without-fixed-intervals") {
        // this.period.range = 'custom';
        // this.period.start.input = moment(value.start).format('DD.MM.YYYY');
        // this.period.end.input = moment(value.end).format('DD.MM.YYYY');
        //
        // this.period.start.highlighted = value.start;
        // this.period.end.highlighted = value.end;
        // this.dateValue = `${this.period.start.input} - ${this.period.end.input}`;
      } else if (
        this.type === undefined ||
        this.type === "text" ||
        this.type === "password" ||
        this.type === "number" ||
        this.type === "price-number" ||
        this.type === "integer-number"
      ) {
        if (value === null) {
          this.textValue = "";
        } else if (this.split) {
          this.textValue = divideNumberIntoClasses(value);
        } else {
          this.textValue = value;
        }
      }
    },
    onInput(e) {
      if (this.type === "textarea") {
        const textareaMaxLength = this.textareaMaxLength !== undefined ? this.textareaMaxLength : 255;

        if (e.target.innerText.length > textareaMaxLength) {
          e.target.innerText = e.target.innerText.substring(0, textareaMaxLength);
          // e.target.getSelection().collapseToEnd();
        }
        this.textValue = e.target.innerText;
      }
    },

    handleInputFocus(e) {
      if (this.copiedToClipboard && !this.editable) {
        e.target.select();
      }
    },

    handleInputTextKeypressed($event) {
      if (this.copiedToClipboard && !this.editable) {
        $event.preventDefault();
      }
      if ($event.type === "keydown" && $event.key === "Enter") {
        this.$emit("enter");
      }
    },

    handleInputPriceKeypressed($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      const value = (this.textValue || "").toString();

      // if (this.textValue.length === 0 && $event.key === '0') {
      //   $event.preventDefault()
      // }

      const isNumber = keyCode >= 48 && keyCode <= 57;
      const isDot = keyCode === 46;
      const hasDot = value.indexOf(".") > -1;
      const isMinus = keyCode === 45;

      if (this.maxLength && value.length >= this.maxLength) {
        $event.preventDefault();
      } else if (isDot) {
        if (!value) $event.preventDefault();
        else if (hasDot) $event.preventDefault();
        else if (this.fractionalLength < 1) $event.preventDefault();
      } else if (isMinus && this.allowNegative) {
        if (value.length) $event.preventDefault();
      } else if (isNumber) {
        if (hasDot) {
          const charsAfterDot = value.split(".")[1].length;
          const fractionalLength = this.fractionalLength || 1;
          //if (charsAfterDot > fractionalLength) $event.preventDefault();
        }
      } else {
        $event.preventDefault();
      }
    },

    async copyToClipboard() {
      const input = document.getElementById("copy-to-clipboard-hidden-input");
      input.setAttribute("type", "text");
      input.select();
      document.execCommand("copy");
      this.$emit("copyToClipboard");
      input.setAttribute("type", "hidden");
      this.$emit("copy");
      // try {
      //   await navigator.clipboard.writeText(this.textValue);
      //   this.$emit('copyToClipboard')
      // }
      // catch (err) {
      //   console.error('Failed to copy: ', err);
      // }
    },

    handleInputNumberKeypressed($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      const value = (this.textValue || "").toString();

      if (this.maxLength && value.length >= this.maxLength) {
        $event.preventDefault();
      }


    },

    handleInputIntegerNumberKeypressed($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;

      if (keyCode === 13) {
        this.$emit("enter");
        return;
      }

      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || this.textValue.indexOf(".") !== -1)) {
        $event.preventDefault();
      }

      if (keyCode === 46) {
        $event.preventDefault();
      }

      if (Number(this.textValue + $event.key) > this.maxIntegerValue) {
        $event.preventDefault();
      }

      /*console.log(123);
      if (this.maxLength && value.length >= this.maxLength) {
        $event.preventDefault();
      }*/

      if ((this.textValue + $event.key).length > 8) {
        $event.preventDefault();
      }

      if (this.textValue && this.textValue.length === 0 && $event.charCode === 48) {
        $event.preventDefault();
      }
    },

    checkTextareaInputSize(e) {
      const textareaMaxLength = this.textareaMaxLength !== undefined ? this.textareaMaxLength : 255;
      const cKey = "c";
      const aKey = "a";
      const backspaceKey = "Backspace";
      const leftKey = "ArrowLeft";
      const rightKey = "ArrowRight";
      const delKey = "Delete";
      const upKey = "ArrowUp";
      const downKey = "ArrowDown";
      const clipBoardData = e.clipboardData || window.clipboardData;
      const pasteTextLength = (clipBoardData ? clipBoardData.getData("text/plain") : "").length;

      if (
        e.key !== backspaceKey &&
        e.key !== leftKey &&
        e.key !== rightKey &&
        e.key !== delKey &&
        e.key !== upKey &&
        e.key !== downKey &&
        !(e.ctrlKey && e.key === aKey) &&
        !(e.ctrlKey && e.key === cKey) &&
        e.target.innerText.length + pasteTextLength >= textareaMaxLength
      ) {
        e.preventDefault();
        return false;
      }
      return true;
    },

    setCurrentDateInputTypeDate() {
      this.textValue = moment().format("DD.MM.YYYY");
      this.dateValue = moment().format("DD.MM.YYYY");
    },

    setDateInputTypeDate(date) {
      this.textValue = date;
      this.dateValue = date;
    },

    periodSubmit() {
      if (this.period.range === "") {
        this.dateValue = "00.00.0000 - 00.00.0000";
        this.container = false;
        return;
      }

      const period = {
        start: null,
        end: null,
      };

      if (this.period.range === "today") {
        this.dateValue = "Сегодня";

        period.start = moment(this.period.end.selected).toDate();
        period.end = moment(this.period.end.selected).toDate();
      } else if (this.period.range === "yesterday") {
        this.dateValue = "Вчера";

        period.start = moment(this.period.end.selected).toDate();
        period.end = moment(this.period.end.selected).toDate();
      } else {
        if (this.period.range === "begin-week") {
          this.dateValue = "C начала недели";
        } else if (this.period.range === "past-week") {
          this.dateValue = "Прошлая неделя";
        } else if (this.period.range === "last-7-days") {
          this.dateValue = "Последние 7 дней";
        } else if (this.period.range === "current-month") {
          this.dateValue = "Текущий месяц";
        } else if (this.period.range === "past-month") {
          this.dateValue = "Прошлый месяц";
        } else if (this.period.range === "last-month") {
          this.dateValue = "Последний месяц";
        }

        if (!moment(this.period.start.highlighted).isValid()) {
          this.period.submitAttempt = true;
          this.period.activeCalendar = "start";
          return;
        }

        if (!moment(this.period.end.highlighted).isValid()) {
          this.period.submitAttempt = true;
          this.period.activeCalendar = "end";
          return;
        }

        if (moment(this.period.start.highlighted).toDate() > moment(this.period.end.highlighted).toDate()) {
          this.period.submitAttempt = true;
          this.period.activeCalendar = "end";
          return;
        }

        period.start = moment(this.period.start.highlighted).toDate();
        period.end = moment(this.period.end.highlighted).toDate();

        if (this.period.range === "custom") {
          this.dateValue = `${this.period.start.input} - ${this.period.end.input}`;
        }
      }

      this.container = false;
      this.$emit("input", period);
      this.$emit("periodChange", period);
    },

    isNotValidPeriodDateStart() {
      if (!this.period.submitAttempt) {
        return false;
      }

      const intViewportWidth = window.innerWidth;

      if (!moment(this.period.start.highlighted).isValid()) {
        if (
          this.period.activeCalendar !== "start" &&
          intViewportWidth < 768 &&
          moment(this.period.end.highlighted).isValid()
        ) {
          // this.period.activeCalendar = 'start'
        }
        return true;
      }

      return false;
    },

    isNotValidPeriodDateEnd() {
      if (!this.period.submitAttempt) {
        return false;
      }

      const intViewportWidth = window.innerWidth;

      if (!moment(this.period.end.highlighted).isValid()) {
        if (
          this.period.activeCalendar !== "end" &&
          intViewportWidth < 768 &&
          moment(this.period.start.highlighted).isValid()
        ) {
          // this.period.activeCalendar = 'end'
        }

        return true;
      }

      const start = moment(this.period.start.highlighted).toDate();
      const end = moment(this.period.end.highlighted).toDate();
      if (start > end) {
        if (
          this.period.activeCalendar !== "end" &&
          intViewportWidth < 768 &&
          moment(this.period.end.highlighted).isValid()
        ) {
          // this.period.activeCalendar = 'end'
        }
        return true;
      }

      return false;
    },

    setCustomPeriod() {
      if (this.period.range !== "custom") this.period.range = "custom";
    },

    dateReset() {
      this.closeContainer();
    },
    dateSubmit() {
      this.savedDate = this.selectedDate;
      this.closeContainer();
    },

    periodReset() {
      this.period.setPeriodFlag = true;
      this.period.range = "custom";

      this.period.start.input = "";
      this.period.end.input = "";

      this.period.end.selected = null;
      this.period.start.selected = null;

      this.period.start.highlighted = null;
      this.period.end.highlighted = null;

      this.dateValue = "";

      setTimeout(() => {
        this.period.submitAttempt = false;
        this.period.setPeriodFlag = false;
      }, 300);
      this.container = false;

      this.$emit("periodChange", { start: null, end: null });
    },

    periodSelectDay(date) {
      if (this.period.start.selected || this.period.end.selected) {
        const startDate = moment(this.period.start.selected);
        const endDate = moment(this.period.end.selected);
        const newDate = moment(date);

        let newStartDate = null;
        let newEndDate = null;

        if (startDate.isSameOrBefore(newDate)) {
          newStartDate = startDate;
          newEndDate = newDate;
        } else if (startDate.isAfter(newDate)) {
          newStartDate = newDate;
          newEndDate = startDate;
        } else if (endDate.isSameOrAfter(newDate)) {
          newStartDate = newDate;
          newEndDate = endDate;
        } else if (endDate.isBefore(newDate)) {
          newStartDate = endDate;
          newEndDate = newDate;
        }

        if (newStartDate) {
          this.period.start.highlighted = newStartDate.toDate();
          this.period.start.input = newStartDate.format("DD.MM.YYYY");
        } else {
          this.period.start.highlighted = null;
        }

        if (newEndDate) {
          this.period.end.highlighted = newEndDate.toDate();
          this.period.end.input = newEndDate.format("DD.MM.YYYY");
        } else {
          this.period.end.highlighted = null;
        }
      }

      if (this.period.start.selected && this.period.end.selected) {
        this.period.start.highlighted = null;
        this.period.end.highlighted = null;
        this.period.start.selected = null;
        this.period.end.selected = null;
      }
    },

    changedStartMonth(value) {
      this.period.endMonth = moment(value).add(1, "month").toDate();
      this.$forceUpdate();
    },

    changedEndMonth(value) {
      this.period.startMonth = moment(value).subtract(1, "month").toDate();
      this.$forceUpdate();
    },

    setPeriod(value) {
      this.period.setPeriodFlag = true;
      const today = moment().startOf("day");

      if (value === "today") {
        this.period.end.selected = moment(today).toDate();
        this.period.start.selected = null;

        this.period.start.highlighted = moment(today).toDate();
        this.period.end.highlighted = moment(today).toDate();

        this.period.start.input = moment(today).format("DD.MM.YYYY").toString();
        this.period.end.input = moment(today).format("DD.MM.YYYY").toString();
      } else if (value === "yesterday") {
        this.period.end.selected = moment(today).subtract(1, "day").toDate();
        this.period.start.selected = null;

        this.period.start.highlighted = moment(today).subtract(1, "day").toDate();
        this.period.end.highlighted = moment(today).subtract(1, "day").toDate();

        this.period.start.input = moment(today).subtract(1, "day").format("DD.MM.YYYY").toString();
        this.period.end.input = moment(today).subtract(1, "day").format("DD.MM.YYYY").toString();
      } else {
        if (value === "begin-week") {
          this.period.start.highlighted = moment(today).startOf("week").toDate();
          this.period.end.highlighted = moment(today).toDate();

          this.period.start.input = moment(today).startOf("week").format("DD.MM.YYYY").toString();
          this.period.end.input = moment(today).format("DD.MM.YYYY").toString();
        } else if (value === "past-week") {
          this.period.start.highlighted = moment(today).startOf("week").subtract(1, "week").toDate();
          this.period.end.highlighted = moment(today).endOf("week").subtract(1, "week").toDate();

          this.period.start.input = moment(today).startOf("week").subtract(1, "week").format("DD.MM.YYYY").toString();
          this.period.end.input = moment(today).endOf("week").subtract(1, "week").format("DD.MM.YYYY").toString();
        } else if (value === "last-7-days") {
          this.period.start.highlighted = moment(today).subtract(6, "day").toDate();
          this.period.end.highlighted = moment(today).toDate();

          this.period.start.input = moment(today).subtract(6, "day").format("DD.MM.YYYY").toString();
          this.period.end.input = moment(today).format("DD.MM.YYYY").toString();
        } else if (value === "current-month") {
          this.period.start.highlighted = moment(today).startOf("month").toDate();
          this.period.end.highlighted = moment(today).toDate();

          this.period.start.input = moment(today).startOf("month").format("DD.MM.YYYY").toString();
          this.period.end.input = moment(today).format("DD.MM.YYYY").toString();
        } else if (value === "past-month") {
          this.period.start.highlighted = moment(today).subtract(1, "month").startOf("month").toDate();
          this.period.end.highlighted = moment(today).subtract(1, "month").endOf("month").toDate();

          this.period.start.input = moment(today).subtract(1, "month").startOf("month").format("DD.MM.YYYY").toString();
          this.period.end.input = moment(today).subtract(1, "month").endOf("month").format("DD.MM.YYYY").toString();
        } else if (value === "last-month") {
          this.period.start.highlighted = moment(today).subtract(1, "month").toDate();
          this.period.end.highlighted = moment(today).toDate();

          this.period.start.input = moment(today).subtract(1, "month").format("DD.MM.YYYY").toString();
          this.period.end.input = moment(today).format("DD.MM.YYYY").toString();
        } else if (value === "custom") {
          // this.period.start.highlighted = null;
          // this.period.end.highlighted = null;
        }

        this.period.end.selected = null;
        this.period.start.selected = null;

        const month = moment().startOf("month");

        this.period.startMonth = moment(month).subtract(1, "month").toDate();
        this.period.endMonth = moment(month).toDate();
      }

      setTimeout(() => {
        this.period.setPeriodFlag = false;
      }, 200);
    },

    selectItem(e, value) {
      if (this.multiple) {
        const selectValue = this.selectValue ? this.selectValue.map((item) => item) : [];

        const result = selectValue.findIndex((item) => item.value === value.value);

        if (result === -1) {
          selectValue.push(value);
        } else if (this.removeSelected) {
          selectValue.splice(result, 1);
        }

        this.selectValue = selectValue;
      } else {
        this.container = false;
        this.selectValue = value;
      }
    },

    selectItemsMobileMultiple() {
      this.container = false;

      const selectValue = [];

      this.checkedMobileMultipleSelects.forEach((item) => {
        selectValue.push(item);
      });

      this.selectValue = [...selectValue];
    },

    listenerHandler(e) {
      if (e.target.closest('.c-input--container-active') !== this.$refs.input) {
        this.closeContainer();
      }
    },

    openContainer() {
      let appSidebar = document.querySelector('.app-sidebar');

      if (this.$refs.inputContainer.getBoundingClientRect().right > document.documentElement.clientWidth) {
        this.correctPositionContainer = "right"
      } 
      if (this.$refs.inputContainer.getBoundingClientRect().left < appSidebar.clientWidth) {
        this.correctPositionContainer = "left"
      }

      if (this.disabled) {
        return;
      }
      this.$emit("container-opened");
      if (this.type === "select" && this.multiple) {
        this.checkedMobileMultipleSelects = [...this.selectValue];
      }
      this.container = true;
      this.selectSearch = "";

      document.addEventListener('click', this.listenerHandler)
    },

    closeContainer() {
      this.container = false;
      this.focused = false;

      this.$emit("container-closed");
      if (this.type === "select" && this.multiple) {
        setTimeout(() => {
          this.checkedMobileMultipleSelects = [...this.selectValue];
        }, 200);
      }

      document.removeEventListener('click', this.listenerHandler)
      // if (this.type === 'period') {
      //   this.periodReset()
      // }
    },

    closeContainerDatepickerContainer(value) {
      if (window.matchMedia("(min-width: 768px)").matches) {
        this.savedDate = value;
        this.closeContainer();
        if (this.$refs.inputdateeditable) {
          this.$refs.inputdateeditable.blur();
        }
      }
    },

    clear() {
      if (this.type === "select" && this.multiple) {
        this.selectValue = [];
      } else {
        this.selectValue = null;
      }
      
      this.dateValue = "";
      this.textValue = "";

      this.$nextTick(() => {
        this.$emit("enter", "reset");
      });

      this.$emit("clearInput");

      // let textarea = document.querySelector('.c-input-textarea-value');
      const textarea = this.$refs.textareaValue;
      if (textarea) {
        textarea.innerHTML = "";
      }

      if (this.type === "period" || this.type === "period-without-fixed-intervals") {
        this.periodReset();
        this.$emit("setPlaceholder");
      }
    },

    dropItem(e, index) {
      e.stopPropagation();
      const c = this.checkedMobileMultipleSelects.findIndex((i) => i.label === this.selectValue[index].label);

      if (c !== -1) {
        this.checkedMobileMultipleSelects.splice(c, 1);
      }

      this.selectValue.splice(index, 1);
    },

    isItemDisabled(item) {
      const i = this.selectItems.find((i) => i.value === item.value);
      if (i && i.disabled) return true;

      if (Array.isArray(this.disabledValues)) {
        const result = this.disabledValues.findIndex((i) => item.value === i);
        return result !== -1;
      }

      if (this.selectValue) {
        if (this.multiple) {
          let result;

          if (Array.isArray(this.selectValue)) {
            result = this.selectValue.findIndex((i) => item.value === i.value);
            return result !== -1;
          }
        } else if (item.value === this.selectValue.value) return true;
      }

      return false;
    },

    isArray(item) {
      return Array.isArray(item);
    },

    getLabel(valueItem) {
      const item = this.selectItems.find((i) => i.value === valueItem.value);
      return item ? item.resultLabel || item.formatLabel || item.label : "";
    },
    focusOnInput() {
      const input = this.$refs["text-input-element"];
      if (input) {
        input.focus();
      }
    },
    focusOnSelect() {
      this.openContainer();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-input-container-date {
  &.with-selects {
    .selects {
      position: relative;
      z-index: 2;
      margin: 20px 0 5px;
      padding: 0 5px;
      display: flex;

      .year {
        width: 60px;
        flex-shrink: 0;
        margin-right: 30px;

        /deep/ {
          .c-select__container {
            min-width: 80px;
          }
        }
      }

      .month {
        flex-grow: 1;
      }
    }

    /deep/ .vdp-datepicker {
      z-index: 1;
    }

    /deep/ .vdp-datepicker {
      .c-input-container-calendar {
        header {
          display: none !important;
        }
      }
    }
  }
}

.list-item-sublabel {
  color: $color-label;
  font-size: 11px;
  margin-top: 2px;
}

.c-input {
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;

  &-required {
    display: flex;
    position: absolute;
    bottom: -20px;
    align-items: center;
    visibility: hidden;
    opacity: 0;
    transition: 0.2s;

    & svg {
      min-height: 14px;
      min-width: 14px;
    }

    &_active {
      height: 14px;
      bottom: -22px;
      visibility: visible;
      opacity: 1;
    }

    &-text {
      white-space: nowrap;
      font-size: 11px;
      color: $color-secondary;
      line-height: 108%;
      margin-left: 6px;
      margin-top: 1px;
    }
  }

  &--disabled {
    filter: opacity(0.4);
    cursor: default;

    .c-input-actions {
      display: none;
    }
    .c-input-input {
      opacity: 0.6;
      cursor: default;
    }
    & .c-input-value_type_select {
      cursor: default;
    }
  }

  &-textarea {
    padding: 0 0 8px 0 !important;
    position: relative;

    &-clearable {
      width: calc(100% - 22px) !important;
    }

    &:focus {
      outline: none;
    }

    &-placeholder {
      color: $color-label;
      position: absolute;
      pointer-events: none;
      top: 0;
      left: 0;
    }

    &-value {
      height: 100%;

      &:focus {
        outline: none;
      }
    }
  }

  &-overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 500;
    visibility: hidden;
    opacity: 0;
    transition: 0.2s;

    &_active {
      visibility: visible;
      opacity: 1;

      @media screen and (max-width: 700px) {
        &_select_mobile {
          background: rgba(0, 0, 0, 0.7);
          transition: 0.3s;
        }
      }
    }
  }

  &-label {
    font: {
      size: 12px;
    }
    line-height: 13px;
    margin-bottom: 10px;
    color: $color-label;
    display: flex;
    align-items: center;

    &-fullname {
      display: inline-block;
      margin-top: -4px;
      margin-left: 3px;
    }

    &__required {
      color: red;
    }
  }

  &-floating-label {
    position: absolute;
    // display: flex;
    align-items: center;
    overflow: hidden !important;
    max-width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    left: 0;
    font: 400 15px Fira Sans;
    pointer-events: none;
    line-height: 13px;
    color: $color-label;
    padding-bottom: 10px;
    padding-top: 8px;
    padding-right: 23px;
    transition: all 200ms;

    .c-input-label-fullname {
      position: absolute;
      top: 1px;
      right: 0;
      pointer-events: all;
      visibility: hidden;
    }

    &-pr {
      padding-right: 15px;
    }

    .c-input-label__required {
      margin-left: -3px;
    }

    &-active {
      font-size: 12px;
      transform: translate3d(0, -100%, 0);
      white-space: normal;
      .c-input-label__required {
        visibility: visible;
      }
      .c-input-label-fullname {
        visibility: visible;
      }
    }
  }

  &-floating-label-not-visible {
    font: {
      size: 12px;
    }
    visibility: hidden;
    line-height: 13px;
    margin-bottom: 10px;
    color: $color-label;
  }

  &-wrapper {
    width: 100%;
    display: flex;
    position: relative;
  }

  &-value {
    width: 100%;
    height: 30px;
    font-size: 15px;
    padding: 0 0 13px 0;
    cursor: pointer;
    order: 2;

    &_size {
      &_small {
        font-size: 13px;
        padding-bottom: 9px;
        height: 30px;
        padding-top: 8px;
      }
    }

    &_placeholder {
      color: $color-label;
    }

    &_type {
      &_select {
        cursor: pointer;
        max-width: calc(100% - 20px);

        &_clearable {
          max-width: calc(100% - 50px);
        }

        &_multiple {
          height: auto;
          min-height: 30px;
          padding-bottom: 0;
          width: calc(100% - 93px);

          &_with_icon {
            width: 100%;
          }

          &_without_checkbox {
            width: 100%;
            max-width: 90%;

            & .c-input-value-multiple {
              //max-width: 180px;
            }

            & .c-input-value-multiple-item {
              //max-width: 180px;
            }
          }
        }
      }
    }

    &-multiple {
      display: flex;
      margin-top: -5px;
      margin-left: -5px;
      flex-wrap: wrap;
      max-width: calc(100% - 10px);

      &-item {
        display: inline-flex;
        align-items: center;
        white-space: nowrap;
        max-width: 90%;
        height: 30px;
        border: 1px solid $color-border;
        font: {
          size: 12px;
          weight: 500;
        }
        border-radius: 15px;
        padding: 0 14px;
        margin-left: 5px;
        margin-bottom: 5px;
        transition: 0.2s;

        &-text {
          max-width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
          font-weight: 500;
        }

        &-close {
          margin-left: 10px;
          // padding-top: 3px;

          svg {
            fill: $color-secondary;
            transition: 0.2s;
          }

          &:hover {
            svg {
              fill: $color-secondary-hover;
            }
          }
        }

        &:hover {
          border-color: $color-button-border-hover;
        }
      }
    }

    &-placeholder {
      padding-top: 5px;
      margin-left: 5px;
      white-space: nowrap;
      color: $color-label;

      &-small {
        padding: 0 5px;
        margin-left: 0;
      }
    }

    &-date {
      color: $color-font;
      margin-top: -2px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      &_placeholder {
        color: $color-label;
      }
    }

    &-single {
      max-width: 100%;
      margin-top: -2px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &-input {
    border: none;
    width: 100%;
    font-size: 15px;
    padding: 0 0 10px 0;
    min-height: 30px;
    order: 2;

    &[disabled] {
      background: white;
    }

    &:focus {
      outline: none;

      & + .c-input-border {
        background: $color-primary;
      }

      & + .c-input-floating-label {
        font-size: 12px;
        line-height: 13px;
        white-space: normal;
        padding-right: 0;
        //font-size: 80%;
        transform: translate3d(0, -100%, 0);
        .c-input-label__required {
          visibility: visible;
        }
      }
    }

    &::placeholder {
      color: $color-label;
    }

    &_floating_label_active + .c-input-floating-label {
      font-size: 12px;
      //font-size: 80%;
      line-height: 13px;
      white-space: normal;
      transform: translate3d(0, -100%, 0);
      padding-right: 0;

      .c-input-label__required {
        visibility: visible;
      }

      .c-input-label-fullname {
        visibility: visible;
      }
    }

    &_placeholder {
      &_italic {
        &::placeholder {
          font-style: italic;
        }
      }
    }

    &_size {
      &_small {
        font-size: 13px;
        padding-bottom: 9px;
        height: 30px;
        padding-top: 8px;
      }
    }

    &_type_number::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    &_type_number {
      -moz-appearance: textfield;
    }
  }

  &-icon {
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    order: 1;
    margin-right: 10px;

    &-svg {
      &_stroke {
        stroke: $color-label;
        fill: none;
      }
    }

    &_right {
      order: 5;
      margin-left: 10px;
      margin-right: 0;
    }

    &-calendar {
      margin-bottom: 5px;
    }

    &_size {
      &_small {
        margin-top: 4px;
      }
    }
  }

  &-actions {
    display: flex;
    order: 3;
    align-items: flex-start;
    margin-left: auto;

    &_size {
      &_small {
        // margin-bottom: 9px;
        margin-top: 4px;
      }
    }
  }

  &-action {
    margin-left: 10px;
    width: 0;

    &_clear {
      margin-top: -3px;
      //transition: .2s;
      opacity: 0;
      visibility: hidden;
      cursor: pointer;

      svg {
        fill: $color-secondary;
      }

      &_active {
        width: auto;
        opacity: 1;
        visibility: visible;
      }
    }

    &_arrow {
      width: auto;
      margin-top: -3px;

      svg {
        fill: $color-label;
        transition: 0.2s;
      }

      &_active {
        svg {
          transform: rotate(180deg);
        }
      }
    }

    &_copy_to_clipboard {
      width: auto;
      cursor: pointer;
      margin-top: -3px;

      svg {
        fill: none;
        transition: 0.2s;
      }
    }
  }

  &-checkbox {
    order: 4;

    &-type-icon {
      margin-left: auto;
    }
  }

  &-border {
    height: 1px;
    width: 100%;
    position: absolute;
    background: $color-control-border;
    bottom: 0;
    transition: 0.2s;

    &_active {
      background: $color-primary;
    }
  }

  &-border-pink {
    background: $color-pink;
  }

  &-container {
    position: absolute;
    background: #ffffff;
    box-shadow: $box-shadow-container;
    border-radius: $border-radius-container;
    z-index: 550;
    top: 50px;
    width: 100%;
    box-sizing: border-box;
    transition: 0.2s;
    opacity: 0;
    visibility: hidden;
    padding: 5px 10px 10px 10px;

    @media screen and (max-width: 700px) {
      position: fixed;
      display: flex;
      flex-direction: column;
      width: calc(100% - 20px);
      height: calc(100% - 30px);
      padding: 5px 15px 20px 15px;
      transition: none;
    }

    &_nolabel {
      top: 27px;

      &.c-input-container_active {
        //top: 37px;
      }

      //@media screen and (max-width: 700px) {
      //  transform: translate(-50%, -50%);
      //  top: 105% !important;
      //  left: 0 !important;
      //}
    }

    &-close {
      display: none;
      position: absolute;
      right: 10px;

      @media (max-width: 767px) {
        display: block;
      }
    }

    &_active {
      //top: 60px;
      top: 100%;
      opacity: 1;
      visibility: visible;

      @media screen and (max-width: 700px) {
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
      }
    }

    &_date {
      width: auto;
      padding: 10px !important;

      .c-input-container-date-actions-mobile {
        display: none;

        &-item {
          width: 100%;
          line-height: 38px;
          text-align: center;
          font: {
            size: 15px;
            weight: 500;
          }

          &:last-child {
            background: $color-primary;
            color: white;
          }
        }
      }

      @media screen and (max-width: 767px) {
        position: fixed;
        width: 100%;
        transform: none !important;
        left: 0;
        top: 0;
        height: auto;
        max-height: 100vh;
        padding: 10px;
        transition: 0.2s;
        padding-bottom: 50px !important;
        border-radius: 0;

        .c-input-container-date {
          width: 260px;
          margin: auto;
          padding-top: 26px;
        }

        .c-input-container-date-actions-mobile {
          display: flex;
          position: absolute;
          width: 100%;
          bottom: 0;
          left: 0;
          margin: 0;
          box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);
        }
      }

      //@media screen and (max-width: 700px) {
      //  width: calc(100% - 20px);
      //
      //  ::v-deep & .vdp-datepicker .vdp-datepicker__calendar {
      //    margin: 0 auto;
      //  }
      //}
    }

    &_period {
      width: auto;
      left: 50%;
      transform: translate(-50%, 0);

      &-without-fixed-intervals {
        min-width: 590px;
        left: 50%;
        transform: translate(-50%, 0);

        @media (max-width: 767px) {
          padding: 15px 10px 10px !important;
          position: fixed !important;
          transform: none !important;
          left: 0;
          top: 0;
          border-radius: 0;
          min-width: 100vw;
          width: 100vw;
          max-height: 100vh;
          height: auto;
          border-radius: 0;

          /deep/ {
            .prev,
            .next {
              visibility: visible !important;
            }
          }

          & .c-input-container-close {
            top: 4px;
            right: 8px;
          }
        }
      }

      @media (max-width: 767px) {
        padding: 15px 10px 10px !important;
        position: fixed;
        transform: none;
        left: 0;
        top: 0;
        border-radius: 0;
        width: 100vw;
        height: 100vh;

        & .c-input-container-close {
          top: 4px;
          right: 8px;
        }
      }
    }

    &_not_searchable {
      padding-top: 10px;
      @include onlyExtraSmall {
        padding-top: 20px;
      }
    }

    &-period {
      padding: 20px 15px 15px;
      display: flex;

      @media (max-width: 767px) {
        flex-direction: column-reverse;
        padding: 7px 10px 10px 10px;
      }

      &-without-fixed-intervals {
        @media screen and (min-width: 768px) {
          flex-direction: column;
        }

        @media screen and (max-width: 767px) {
          padding: 23px 10px 10px 10px;
        }

        &::v-deep .c-input-container-period-right {
          margin-left: auto;
        }

        &::v-deep .c-input-container-period-actions {
          margin-top: 20px;
        }
      }

      &-switcher {
        display: none;

        @media (max-width: 767px) {
          display: flex;
          margin: 0 -20px;
          border-top: 1px solid $color-border-light;
          padding: 0 20px;
        }

        &-item {
          width: 100%;
          display: flex;
          align-items: center;
          font: {
            size: 13px;
            weight: 500;
          }
          color: $color-primary;

          span {
            position: relative;
            display: inline-block;
            line-height: 40px;

            &:before {
              position: absolute;
              content: "";
              height: 4px;
              width: 100%;
              background: $color-secondary;
              top: 40px;
              opacity: 0;
              visibility: hidden;
              transition: 0.2s;
            }
          }

          &_active {
            color: $color-font;

            span {
              &:before {
                opacity: 1;
                visibility: visible;
              }
            }
          }
        }
      }

      &-calendars {
        display: flex;

        @media (max-width: 767px) {
          margin: 0 -20px;
          padding: 20px;
          position: relative;
          height: 330px;

          &:before {
            content: "";
            position: absolute;
            width: 100%;
            height: 12px;
            background: linear-gradient(0, #8e9cbb 0%, #ffffff 100%);
            opacity: 0.2;
            top: -12px;
            left: 0;
          }
        }

        &_disabled {
          pointer-events: none;
        }

        &-item {
          &:first-child {
            margin-right: 23px;
          }

          @media (max-width: 767px) {
            position: absolute;
            opacity: 0;
            visibility: hidden;
            transition: 0.2s;
            width: calc(100% - 40px);

            &:first-child {
              margin-right: 0;
            }

            &_active {
              opacity: 1;
              visibility: visible;
            }
          }
        }
      }

      &-calendar {
        @media (max-width: 767px) {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }

      &-input {
        width: 100%;
        height: 30px;
        font-size: 15px;
        padding: 0 0 15px 0;
        border: none;

        &[disabled] {
          background: white;
        }

        &::placeholder {
          color: $color-label;
        }

        &:focus {
          outline: none;
        }

        &-wrapper {
          display: flex;
          width: 100%;
          border-bottom: 1px solid $color-border;

          &-required {
            border-bottom: 1px solid $color-error;
          }
        }

        &-icon {
          margin-top: -4px;
        }
      }

      &-right {
        margin-left: 25px;

        @media (max-width: 700px) {
          margin-left: 0;
        }
      }

      &-links {
        margin-top: -12px;

        @media (max-width: 767px) {
          height: 150px;
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          margin-bottom: 10px;
        }
        @media (max-width: 320px) {
          height: 135px;
          margin-bottom: 5px;
        }
      }

      &-link {
        line-height: 30px;
        font: {
          size: 13px;
          weight: 500;
        }
        color: $color-primary;
        cursor: pointer;
        transition: 0.2s;

        @media (max-width: 767px) {
          width: 50%;
          line-height: 16px;
          padding: 7px 0;
        }
        @media (max-width: 320px) {
          padding: 5px 0;
        }

        &_active {
          color: $color-label;
        }
      }

      &-actions {
        display: flex;
        margin-top: 10px;

        @media (max-width: 767px) {
          display: none;
        }

        &-mobile {
          display: none;

          @media (max-width: 767px) {
            display: flex;
            position: absolute;
            width: 100%;
            bottom: 0;
            left: 0;
            margin: 0;
            box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);
          }

          &-item {
            width: 100%;
            line-height: 38px;
            text-align: center;
            font: {
              size: 15px;
              weight: 500;
            }

            &:last-child {
              background: $color-primary;
              color: white;
            }
          }
        }
      }

      &-action {
        &:first-child {
          margin-right: 10px;
        }
      }
    }

    &_size {
      &_small {
        //top: 20px;

        &.c-input-container {
          &_active {
            //top: 30px;
          }

          .c-input-container-list {
            &-item {
              min-height: 24px;

              &-label {
                font-size: 13px;
              }
            }
          }
        }
      }
    }

    &-search {
      display: flex;
      align-items: center;
      position: relative;
      padding: 10px;
      margin-bottom: 13px;

      &-icon {
        margin-right: 7px;
        margin-top: -2px;

        svg {
          stroke: $color-label;
          fill: none;
        }

        &-clear {
          position: absolute;
          cursor: pointer;
          top: calc(50% - 1px);
          transform: translate(0, -50%);
          right: 10px;
        }
      }

      &-input {
        border: none;
        height: 17px;
        margin-top: -2px;
        font-size: 13px;
        max-width: calc(100% - 40px);

        &:focus {
          outline: none;
        }

        &::placeholder {
          font-style: italic;
          color: $color-label;
        }
      }

      &-border {
        height: 1px;
        background: $color-border;
        width: calc(100% - 20px);
        position: absolute;
        bottom: 2px;
        transition: 0.2s;
      }

      &-with-special-value {
        margin-bottom: 5px;
      }
    }

    &-list {
      max-height: 200px;
      overflow-x: auto;

      &-active {
        display: block !important;
      }

      @media screen and (max-width: 700px) {
        display: none;
        max-height: calc(100% - 46px);
      }

      &-mobile {
        display: none;

        &-buttons {
          display: none;
          margin: 0 0 0 10px;
        }

        @media screen and (max-width: 700px) {
          display: block !important;

          &-buttons {
            display: flex;
            position: relative;
            margin-top: auto;
            padding-top: 12px;
            align-items: flex-end;

            & .c-button_size_small {
              padding: 8px 20px;
            }

            &-cancel {
              margin-right: 5px;
            }

            &:before {
              content: "";
              position: absolute;
              pointer-events: none;
              width: 100%;
              height: 25px;
              top: -20px;
              left: 0;
              background: linear-gradient(rgba(255, 255, 255, 0) 0, #ffffff 100%);
            }
          }
        }

        & .c-input-container-list-item {
          padding: 0 10px;
        }

        & .c-input-container-list-item:hover {
          background: none;
        }
      }

      &::-webkit-scrollbar {
        width: 4px;
        height: 100%;
        background: white;
        cursor: pointer;
      }

      &::-webkit-scrollbar-thumb {
        background: $color-secondary;
        border-radius: 2px;
      }

      &::-webkit-scrollbar-track {
        background: $color-border-alt;
        width: 4px;
        border-radius: 2px;
      }

      &-item {
        font: {
          size: 15px;
        }
        min-height: 30px;
        padding: 0 14px;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: 0.1s;
        border-radius: 15px;

        &:hover {
          background: $color-bg-hover;
        }

        &_selected {
          @media screen and (max-width: 700px) {
            background: $color-bg-hover;
          }
        }

        &_empty {
          pointer-events: none;
          line-height: 1.2;

          color: $color-label;

          &_size_small {
            font-size: 12px;
          }
        }

        &_disabled {
          pointer-events: none;
          color: $color-label;
        }

        &_special {
          position: relative;
          margin-bottom: 14px;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;

          & .c-input-container-list-item-border {
            bottom: -7px;
          }
        }

        &_category {
          font-weight: 500;
          font-size: 15px;
          color: #000000;

          &.c-input-container-list-item_disabled {
            color: #8e9cbb;
          }
        }

        &_with_avatar {
          min-height: 44px;
          border-radius: 22px;
          padding-left: 10px;
        }

        &-avatar {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          margin-right: 10px;
          flex-shrink: 0;
        }

        &-label {
          max-width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;

          &-bold {
            font-weight: 500;
          }
        }

        &-border {
          position: absolute;
          bottom: -14px;
          left: 10px;
          width: calc(100% - 20px);
          height: 1px;
          background: $color-control-border;
        }
      }
    }
  }

  .is-invalid &,
  &.is-invalid {
    .c-input-border {
      background: $color-error;
    }
  }
}

.input-arrow {
  position: absolute;
  left: 0;
  bottom: 9px;
}
.ml-22 {
  margin-left: 22px;
}

.c-input--container-active {
  &[data-type="date"],
  &[data-type="period-without-fixed-intervals"] {
    @media screen and (max-width: 767px) {
      .c-input-overlay {
        background-color: rgba(0, 0, 0, 0.7);
        cursor: pointer;
        visibility: visible;
        opacity: 1;
      }
    }
  }
}

.error-messages {
  display: flex;
  align-items: flex-start;
  margin-top: 7px;
  line-height: 108%;
  font-size: 11px;
  color: $color-secondary;

  &__icon {
    height: 14px;
    width: 14px;
    margin-right: 5px;
  }

  &__list {
    display: flex;
    flex-direction: column;
    margin-top: 2px;
    gap: 5px;
  }
}

.c-input-container_right {
  left: unset;
  right: 0;
  transform: unset;
}
.c-input-container_left {
  left: 0;
  right: unset;
  transform: unset;
}
</style>
